exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date-option {\n  width: 100% !important;\n  height: 40px !important; }\n  .date-option p-calendar ::ng-deep .ui-calendar {\n    width: 100%;\n    height: 40px; }\n  .date-option p-calendar ::ng-deep .ui-inputtext {\n    width: 100%;\n    height: 40px;\n    background: #ffffff;\n    color: #acb6bf;\n    transition: .2s; }\n  .date-option p-calendar ::ng-deep .ui-state-default {\n    border: none; }\n  .date-option p-calendar ::ng-deep .ui-inputtext:focus {\n    box-shadow: none !important; }\n  .date-option p-calendar ::ng-deep .ui-inputtext {\n    padding: 0 10px; }\n  .date-option p-calendar ::ng-deep .ui-state-active {\n    background-color: #14CC9E !important;\n    color: #ffffff; }\n  .date-option p-calendar ::ng-deep .ui-datepicker {\n    width: auto;\n    padding: .2em;\n    display: none;\n    position: absolute; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /data/wwwroot/xzhipin/app-client/src/app/user/date-option/date-option.component.scss
// module id = ../../../../../src/app/user/date-option/date-option.component.scss
// module chunks = common